import moment from 'moment'

export function formatDate(dateString) {
    const date = moment(dateString);
    return {
        date: date.format('DD.MM.YYYY'),
        time: date.format('HH:mm:ss')
    }
}

/**
 * Format a date for backend APIs that expect naive UTC datetimes (no timezone suffix).
 * Equivalent to Python: datetime.now(timezone.utc).replace(tzinfo=None)
 */
export function toUtcNaiveDateTime(value) {
    if (value == null) return null
    const iso = (value instanceof Date ? value : new Date(value)).toISOString()
    return iso.replace('Z', '')
}

/** History end date: includes the full selected day (sends start of next day). */
export function toUtcNaiveDateTimeInclusiveEndDate(value) {
    if (value == null) return null

    const date = value instanceof Date ? value : new Date(value)
    const nextDayStart = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() + 1,
        0,
        0,
        0,
        0,
    )

    return nextDayStart.toISOString().replace('Z', '')
}